module.exports = __webpack_public_path__ + "img/classify_11.9298fc26.png";